module.exports = __webpack_public_path__ + "img/homeBottom.5b94d635.png";